import React, { ComponentProps, useEffect, useState } from 'react'
import { useFormContext, get, RegisterOptions } from 'react-hook-form'
import { CheckBox } from '@/components/atoms/CheckBox'

type Props = ComponentProps<typeof CheckBox> & {
  name: string
  value?: string | number
  registerOptions?: RegisterOptions
}

const InnerFormCheckBox = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>,
) => {
  const { register, formState, watch } = useFormContext()
  const { errors } = formState
  const { registerOptions, ...inputProps } = props
  const methods = register(props.name, registerOptions)
  const defaultValue = props.value || true

  const currentValue = watch(props.name)

  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (currentValue !== undefined) {
      setChecked(
        Array.isArray(currentValue)
          ? currentValue.includes(defaultValue)
          : defaultValue === currentValue,
      )
    }
  }, [setChecked, currentValue, defaultValue])

  return (
    <CheckBox
      {...inputProps}
      // eventを通すと、numberもstringになるので、緩い判定にする
      checked={checked}
      isError={get(errors, props.name)}
      ref={(el) => {
        methods.ref(el)
        if (typeof ref === 'function') {
          ref(el)
          return
        }
        if (ref) {
          ref.current = el
        }
      }}
      onChange={(e) => {
        methods.onChange(e)
        props.onChange && props.onChange(e)
      }}
      onBlur={(e) => {
        methods.onBlur(e)
        props.onBlur && props.onBlur(e)
      }}
    />
  )
}

export const FormCheckBox = React.forwardRef(InnerFormCheckBox)